export default __webpack_public_path__ + "static/media/slider-10.01c0aaf6.png";